<!-- Display only IF the image property is set otherwise it will not display. -->
<div class="mod-unit i6x1" *ngIf="!!imageSrc">
    <div class="mod-unit__default-banner">
        <a *ngIf="!!promoLinkPath"
           href="{{promoLinkPath}}" tabindex="0" role="link"
           target="{{openInNewTab == true ? '_blank' : ''}}"
           class="block-start-height"
           [attr.aria-label]="promoAltText + ((openInNewTab == true) ? ' - opens in a new tab' : '.')">
            <picture class="mod-unit__image">
                <!-- Tablet and mobile view  -->
                <source media="(max-width: 1023px)" srcset="{{imageSrc}}?$mod-unified-tab-view$">
                <!-- Append $mod-unified-desktop$ preset to image path only if Image ratio is 6:1-->
                <img src="{{imageSrc}}?$mod-unified-desktop$" alt="{{promoAltText}}" loading="lazy">
            </picture>
        </a>
        <ng-container *ngIf="!promoLinkPath">
            <picture class="mod-unit__image">
                <!-- Tablet and mobile view  -->
                <source media="(max-width: 1023px)" srcset="{{imageSrc}}?$mod-unified-tab-view$">
                <!-- Append $mod-unified-desktop$ preset to image path only if Image ratio is 6:1-->
                <img src="{{imageSrc}}?$mod-unified-desktop$" alt="{{promoAltText}}" loading="lazy">
            </picture>
        </ng-container>
        <div *ngIf="textPlateDisplay" class="mod-unit__card">
            <div class="mod-unit__headline" *ngIf="!!textPlateHeaderText" [innerHTML]="textPlateHeaderText"></div>
            <div class="mod-unit__paragraph" *ngIf="!!textPlateSubText" [innerHTML]="textPlateSubText"></div>
            <a *ngIf="!!textPlateCTALabel && !!promoLinkPath" href="{{promoLinkPath}}"
               class="mod-unit__cta-button mod-unit--cta-position"
               target="{{openInNewTab == true ? '_blank' : ''}}"
               [attr.aria-label]="textPlateCTALabel + ((openInNewTab == true) ? ' - opens in a new tab' : '.')">
                {{textPlateCTALabel}}
                <svg class="svg-icon svg-icon-grey-chevron mod-unit__caret-right" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 24 24">
                    <path fill="#4B4B4B" d="M9.984 12L17 18.651 15.438 20 7 12 15.438 4 17 5.349z"
                          transform="matrix(-1 0 0 1 24 0)"/>
                </svg>
            </a>
            <hr *ngIf="!textPlateCTALabel && !promoLinkPath" class="mod-unit__separator mod-unit--cta-position" />
        </div>
    </div>
</div>
